/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'email': 'E-Mail',
    'first_name': 'Vorname',
    'forgot': 'Zurücksetzen',
    'forgot_description': 'Gib deine E-Mail Adresse ein',
    'forgot_heading': 'Passwort zurücksetzen',
    'forgot_password': 'Passwort vergessen?',
    'forgot_success_body': 'Bitte überprüfe dein Email Postfach.',
    'forgot_success_title': 'Email gesendet!',
    'goto_login': 'Zurück zum einloggen',
    'last_name': 'Nachname',
    'login': 'Einloggen',
    'login_description': 'Gib deine Zugangsdaten ein',
    'login_heading': 'Einloggen',
    'otp_checking': 'Zwei-Faktor-Code wird überprüft.',
    'otp_code': 'Zwei-Faktor-Authentifizierungs Code',
    'password': 'Passwort',
    'password_confirmation': 'Passwort wiederholen',
    'password_confirmation_invalid': 'Die Passwörter stimmen nicht überein',
    'password_new': 'Neues Passwort',
    'privacy_policy': 'Datenschutzerklärung',
    'register': 'Registrieren',
    'register_description': 'Gib deine Daten ein',
    'register_heading': 'Registrieren',
    'reset': 'Zurücksetzen',
    'reset_description': 'Gib dein neues Passwort ein',
    'reset_heading': 'Passwort zurücksetzen',
    'reset_success_body': 'Du wirst in 5 Sekunden automatisch zur Login-Seite weitergeleitet.',
    'reset_success_title': 'Passwort wurde zurückgesetzt!',
    'singup_newsletter_text': 'Ich möchte Neuigkeiten und nützliche Tipps per E-Mail erhalten.',
    'tfa': 'Zwei-Faktor-Authentifizierung',
    'tfa_description': 'Gib dein Einmalpasswort ein oder nutze einen Ersatzcode',
    'tfa_disabled': 'Zwei-Faktor-Authentifizierung wurde erfolgreich deaktiviert.',
    'tfa_enabled': 'Zwei-Faktor-Authentifizierung wurde erflogreich aktiviert. Bitte melde dich erneut an.',
    'tfa_heading': 'Zwei-Faktor-Authentifizierung',
    'tos': 'AGB',
    'tos_acceptance': 'Ich habe die {tos} und die {privacyPolicy} gelesen und akzeptiere diese.',
    'tos_privacy': 'AGB und Datenschutz',
    'user_deleted_body': 'Du wirst in 5 Sekunden automatisch zur Login-Seite weitergeleitet.',
    'user_deleted_title': 'Account wurde gelöscht',
    'verify_body': 'Du wirst in 5 Sekunden automatisch zur Login-Seite weitergeleitet.',
    'verify_title': 'Konto verifiziert'
  },

  /* english */
  en: {
    'email': 'Email',
    'first_name': 'First name',
    'forgot': 'Reset',
    'forgot_description': 'Enter your E-Mail address below',
    'forgot_heading': 'Reset password',
    'forgot_password': 'Forgot password?',
    'forgot_success_body': 'Please check your inbox for further instructions.',
    'forgot_success_title': 'Email was sent!',
    'goto_login': 'Go to login',
    'last_name': 'Last name',
    'login': 'Login',
    'login_description': 'Enter your credentials below',
    'login_heading': 'Login',
    'otp_checking': 'Checking two factor code.',
    'otp_code': 'Two factor authentication code',
    'password': 'Password',
    'password_confirmation': 'Repeat password',
    'password_confirmation_invalid': 'The passwords do not match',
    'password_new': 'New password',
    'privacy_policy': 'Privacy Policy',
    'register': 'Register',
    'register_description': 'Enter your account data below',
    'register_heading': 'Register',
    'reset': 'Reset',
    'reset_description': 'Enter a new password below',
    'reset_heading': 'Reset password',
    'reset_success_body': 'You will be redirected to the login page in 5 seconds.',
    'reset_success_title': 'Your password has been reset!',
    'singup_newsletter_text': 'I want to get news and useful tips in my inbox.',
    'tfa': 'Two factor authentication',
    'tfa_description': 'Enter your one time password or use one of your backup codes',
    'tfa_disabled': 'Two factor authentication has been disabled.',
    'tfa_enabled': 'Two factor authentication has been enabled. Please log in again.',
    'tfa_heading': 'Two factor authentication',
    'tos': 'Terms & Conditions',
    'tos_acceptance': 'I have read and accept the {tos} and {privacyPolicy}.',
    'tos_privacy': 'Terms & Conditions and Privacy Policy',
    'user_deleted_body': 'You will be redirected to the login page in 5 seconds.',
    'user_deleted_title': 'Account has been deleted',
    'verify_body': 'You will be redirected to the login page in 5 seconds.',
    'verify_title': 'Account verified'
  }
}
